(function() {
    'use strict';

    angular.module('adminApp.wit', ['ui.bootstrap', 'dndLists', 'frapontillo.bootstrap-switch', 'smart-table']);
})();
